<template>
  <div class="container">
    <!-- <div id="wrapper" v-if="!isLogin" >
      <login/>
    </div> -->
    <div class="loading"> 
      <div class="chat-wrapper">
        <!-- <el-row style="margin:20px 0px 20px 0px;margin-bottom:10px;">
          <el-col
            :span="3"
            :class="buttonSelect===6?'buttonStyle':'buttonStyleNo'"
            @click.native="changeSelect(6)"
          >
            <span>全部应聘者</span>
          </el-col>

          <el-col
            :class="buttonSelect===7?'buttonStyle':'buttonStyleNo'"
            @click.native="changeSelect(7)"
          >
            <span>新招呼</span>
          </el-col>

          <el-col
            :class="buttonSelect===1?'buttonStyle':'buttonStyleNo'"
            @click.native="changeSelect(1)"
          >
            <span>沟通中</span>
          </el-col>
          <el-col
            :class="buttonSelect===2?'buttonStyle':'buttonStyleNo'"
            @click.native="changeSelect(2)"
          >
            <span>已约面试</span>
          </el-col>
          <el-col
            :class="buttonSelect===3?'buttonStyle':'buttonStyleNo'"
            @click.native="changeSelect(3)"
          >
            <span>不合适</span>
          </el-col>
          <el-col
            :class="buttonSelect===4?'buttonStyle':'buttonStyleNo'"
            @click.native="changeSelect(4)"
          >
            <span>已入职</span>
          </el-col>
          <el-col
            :class="buttonSelect===5?'buttonStyle':'buttonStyleNo'"
            @click.native="changeSelect(5)"
          >
            <span>已拉黑</span>
          </el-col>
        </el-row> -->
        <el-row>
          <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="5">
            <side-bar />
          </el-col>
          <el-col :xs="18" :sm="18" :md="18" :lg="18" :xl="19">
            <current-conversation />
          </el-col>
        </el-row>
      </div>
      <call-layer ref="callLayer" class="chat-wrapper"/>
      <image-previewer />
    </div>
    <div class="bg">
    </div>
  </div>
</template>

<script>
import { Notification } from "element-ui";
import { mapState } from "vuex";
import CurrentConversation from "../../components/im/conversation/current-company-conversation";
import SideBar from "../../components/im/layout/side-company-bar";
import Login from "../../components/im/user/login";
import ImagePreviewer from "../../components/im/message/image-previewer.vue";
import { translateGroupSystemNotice } from "../../utils/common";
import CallLayer from "../../components/im/message/call-layer";
import { ACTION } from "../../utils/trtcCustomMessageMap";
import MTA from "../../utils/mta";
import Vue from 'vue';
import { createIMToDisabled } from '@/comm/api'
import { getAction , postAction , putAction} from '@/comm/manage';
import { cleanUserInfo,getUserSig } from "@/comm/api";

export default {
  title: 'Chat',

  components: {
    Login,
    SideBar,
    CurrentConversation,
    ImagePreviewer,
    CallLayer
  },
  data() {
    return {
      btns: [
        { name: "全部应聘者" },
        { name: "新招呼" },
        { name: "沟通中" },
        { name: "已约面试" },
        { name: "不合适" },
        { name: "已入职" },
        { name: "已拉黑" }
      ],
      buttonSelect: 6,
      backConversationList:[]
      // tsdisabledpositionrefs:[]
    }
  },
  computed: {
    ...mapState({
      conversationList: state => state.conversation.conversationList,
      currentUserProfile: state => state.user.currentUserProfile,
      currentConversation: state => state.conversation.currentConversation,
      isLogin: state => state.user.isLogin,
      isSDKReady: state => state.user.isSDKReady,
      isBusy: state => state.video.isBusy,
      userID: state => state.user.userID
    }),
    // 是否显示 Loading 状态
    showLoading() {
      return !this.isSDKReady
    }
  },

  mounted() {
    // 初始化监听器
    this.initListener();
    //如果获取不到用户信息，执行退出
    let userInfo = this.$store.state.users.userInfo;
    if (!userInfo) {
      cleanUserInfo();
      this.$router.push("/");
      return;
    }

    // console.log("this.$store.state.sys_dicts.currentCIMItem.udId",this.$store.state.sys_dicts.currentCIMItem.udId)

    // if(!this.isSDKReady){
      //用户登录IM
      this.getIMInstance();
    // }else if(this.$store.state.sys_dicts.currentCIMItem.udId){
      // this.$store.dispatch('getHrConversationProfile','C2C'+this.$store.state.sys_dicts.currentCIMItem.udId).then(() =>{})
    // }
    
    //加载已经沟通过的职位信息
    // this.loadDisablePosRefs();

  },

  watch: {
    isLogin(next) {
      if (next) {
        MTA.clickStat('link_two', { show: 'true' })
      }
    }
  },

  methods: {
    initListener() {
      // 登录成功后会触发 SDK_READY 事件，该事件触发后，可正常使用 SDK 接口
      this.tim.on(this.TIM.EVENT.SDK_READY, this.onReadyStateUpdate, this)
      // SDK NOT READT
      this.tim.on(this.TIM.EVENT.SDK_NOT_READY, this.onReadyStateUpdate, this)
      // 被踢出
      this.tim.on(this.TIM.EVENT.KICKED_OUT, this.onKickOut)
      // SDK内部出错
      this.tim.on(this.TIM.EVENT.ERROR, this.onError)
      // 收到新消息
      this.tim.on(this.TIM.EVENT.MESSAGE_RECEIVED, this.onReceiveMessage)
      // 会话列表更新
      this.tim.on(this.TIM.EVENT.CONVERSATION_LIST_UPDATED, this.onUpdateConversationList)
      // 群组列表更新
      this.tim.on(this.TIM.EVENT.GROUP_LIST_UPDATED, this.onUpdateGroupList)
      // 网络监测
      this.tim.on(this.TIM.EVENT.NET_STATE_CHANGE, this.onNetStateChange)
      // 已读回执
      this.tim.on(this.TIM.EVENT.MESSAGE_READ_BY_PEER, this.onMessageReadByPeer)

    },
    loadDisablePosRefs(){
      let userInfo = Vue.ls.get('Login_Userinfo');
      let params = {ucPhone:userInfo.ucPhone};
      getAction('/tsdisabledpositionref/tsDisabledPositionRef/list',params).then(res =>{
        if(res.success){
          this.$store.commit('SET_TSDISABLEDPOSITIONREFS', res.result.records);
          // this.tsdisabledpositionrefs = res.result.records;
          this.getFilterList();
        }else{
          console.log("获取沟通记录错误")
        }
      })
    },
    changeSelect(index) {
      this.buttonSelect = index;
      this.$store.commit('SET_CURRENTINDEX', index);
      this.$store.commit('updateCurrentConversation',[]);
      this.loadDisablePosRefs();
    },
    getFilterList(){
      let index = this.$store.state.friend.currentIndex;
      let tempArr = [];
      if(index !== 6 && index !== 7 ){
        this.backConversationList.filter(item => {
          if(this.getComp(item, index)){
            tempArr.push(item);
          }
        })
        this.$store.commit('updateConversationList',tempArr);
      }else{
        this.$store.commit('updateConversationList',this.backConversationList);
      }
    },
    getComp(conversation, index){
      let arr = this.$store.state.friend.tsdisabledpositionrefs;
      let result = false;
      arr.map(item => {
        if(conversation.conversationID){
          if(conversation.conversationID.replace('C2C','') == item.udId && item.status == index){
            result = true;
          }
        }
      })
      return result;
    },
    getIMInstance(){
      let userInfo = Vue.ls.get('UserInfo');
      // let userSigObj = Vue.ls.get('userSig');
      // let userSig = "";
      getUserSig(userInfo.ucPhone).then(sig => {
        console.log(userInfo.ucPhone, sig)
        this.login(userInfo.ucPhone,sig);
      })
    },
    login(userid,userSig) {
      // this.loading = true;
      this.tim
        .login({
          userID: userid,
          userSig: userSig
        })
        .then(() => {
          this.loading = false
          this.$store.commit('toggleIsLogin', true)
          this.$store.commit('startComputeCurrent')
          this.$store.commit({
            type: 'GET_USER_INFO',
            userID: userid,
            userSig: userSig,
            sdkAppID: 1400612379
          })
          // this.$store.commit('showMessage', {
          //   type: 'success',
          //   message: '登录成功'
          // })

          this.backConversationList = JSON.parse(JSON.stringify(this.conversationList));  
        })
        .catch(error => {
          this.loading = false;
          this.$store.commit('showMessage', {
            message: '聊天登录失败：' + error.message,
            type: 'error'
          })
        })
    },
    onReceiveMessage({ data: messageList }) {
      this.handleVideoMessage(messageList)
      this.handleAt(messageList)
      this.handleQuitGroupTip(messageList)
      this.$store.commit('pushCurrentMessageList', messageList)
    },
    onError({ data }) {
      if (data.message !== 'Network Error') {
        // this.$store.commit('showMessage', {
        //   message: data.message,
        //   type: 'error'
        // })
        console.log('error',data.message);
        this.getIMInstance();
      }
    },
    onMessageReadByPeer() {

    },
    onReadyStateUpdate({ name }) {
     
      const isSDKReady = name === this.TIM.EVENT.SDK_READY ? true : false
      this.$store.commit('toggleIsSDKReady', isSDKReady)

      if (isSDKReady) {
        console.log('company ready....')
        this.tim
          .getMyProfile()
          .then(({ data }) => {
            this.$store.commit('updateCurrentUserProfile', data)
          })
          .catch(error => {
            // this.$store.commit('showMessage', {
            //   type: 'error',
            //   message: error.message
            // })
            console.log('error',error.message)
          })
        this.$store.dispatch('getBlacklist')

        //根据职位跳转到IM并选择当前用户
        if (this.$store.state.sys_dicts.currentCIMItem.udId) {
          this.$store.dispatch('getHrConversationProfile','C2C'+this.$store.state.sys_dicts.currentCIMItem.udId).then(() =>{})
          // setTimeout(() => {
          //   const message = this.tim.createTextMessage({
          //     to: this.$store.state.sys_dicts.currentCIMItem.udPhone,
          //     conversationType: 'C2C',
          //     payload: { text: "你好，请问还在找工作吗？" }
          //   })
          //   this.$store.commit('pushCurrentMessageList', message)
          //   this.$bus.$emit('scroll-bottom')
          //   this.tim.sendMessage(message).catch(error => {
          //     this.$store.commit('showMessage', {
          //       type: 'error',
          //       message: error.message
          //     })
          //   })        
          // }, 1000); 
        }
      }
    },
    kickedOutReason(type) {
      switch (type) {
        case this.TIM.TYPES.KICKED_OUT_MULT_ACCOUNT:
          return '由于多实例登录'
        case this.TIM.TYPES.KICKED_OUT_MULT_DEVICE:
          return '由于多设备登录'
        case this.TIM.TYPES.KICKED_OUT_USERSIG_EXPIRED:
          return '由于 userSig 过期'
        default:
          return ''
      }
    },
    checkoutNetState(state) {
      switch (state) {
        case this.TIM.TYPES.NET_STATE_CONNECTED:
          return { message: '已接入网络', type: 'success' }
        case this.TIM.TYPES.NET_STATE_CONNECTING:
          return { message: '当前网络不稳定', type: 'warning' }
        case this.TIM.TYPES.NET_STATE_DISCONNECTED:
          return { message: '当前网络不可用', type: 'error' }
        default:
          return ''
      }
    },
    onNetStateChange(event) {
      // this.$store.commit('showMessage', this.checkoutNetState(event.data.state))
      // console.log(this.checkoutNetState(event.data.state));
    },
    onKickOut(event) {
      this.$store.commit('showMessage', {
        message: `${this.kickedOutReason(event.data.type)}被踢出，请重新登录。`,
        type: 'error'
      })
      this.$store.commit('toggleIsLogin', false)
      this.$store.commit('reset')
      this.$router.push("./pcLoginMessage");
    },
    onUpdateConversationList(event) {
      this.$store.commit('updateConversationList', event.data)
    },
    onUpdateGroupList(event) {
      this.$store.commit('updateGroupList', event.data)
    },
    onReceiveGroupSystemNotice(event) {
      const isKickedout = event.data.type === 4
      const isCurrentConversation =
        `GROUP${event.data.message.payload.groupProfile.groupID}` ===
        this.currentConversation.conversationID
      // 在当前会话被踢，需reset当前会话
      if (isKickedout && isCurrentConversation) {
        this.$store.commit('resetCurrentConversation')
      }
      Notification({
        title: '新系统通知',
        message: translateGroupSystemNotice(event.data.message),
        duration: 3000,
        onClick: () => {
          const SystemConversationID = '@TIM#SYSTEM'
          this.$store.dispatch('checkoutConversation', SystemConversationID)
        }
      })
    },
    /**
     * 处理 @ 我的消息
     * @param {Message[]} messageList
     */
    handleAt(messageList) {
      // 筛选有 @ 符号的文本消息
      const atTextMessageList = messageList.filter(
        message =>
          message.type === this.TIM.TYPES.MSG_TEXT &&
          message.payload.text.includes('@')
      )
      for (let i = 0; i < atTextMessageList.length; i++) {
        const message = atTextMessageList[i]
        const matched = message.payload.text.match(/@\w+/g)
        if (!matched) {
          continue
        }
        // @ 我的
        if (matched.includes(`@${this.currentUserProfile.userID}`)) {
          // 当前页面不可见时，调用window.Notification接口，系统级别通知。
          if (this.$store.getters.hidden) {
            this.notifyMe(message)
          }
          Notification({
            title: `有人在群${message.conversationID.slice(5)}提到了你`,
            message: message.payload.text,
            duration: 3000
          })
          this.$bus.$emit('new-messsage-at-me', {
            data: { conversationID: message.conversationID }
          })
        }
      }
    },
    selectConversation(conversationID) {
      if (conversationID !== this.currentConversation.conversationID) {
        this.$store.dispatch('checkoutConversation',conversationID)
      }
    },
    isJsonStr(str) {
      try{
        JSON.parse(str)
        return true
      }catch {
        return false
      }
    },
    handleVideoMessage(messageList) {
      const videoMessageList = messageList.filter(
        message => message.type === this.TIM.TYPES.MSG_CUSTOM && this.isJsonStr(message.payload.data)
      )
      if (videoMessageList.length === 0) return
      const videoPayload = JSON.parse(videoMessageList[0].payload.data)
      if (videoPayload.action === ACTION.VIDEO_CALL_ACTION_DIALING) {
        if (this.isBusy) {
          this.$bus.$emit('busy', videoPayload, videoMessageList[0])
          return
        }
        this.$store.commit('GENERATE_VIDEO_ROOM', videoPayload.room_id)
        this.selectConversation(videoMessageList[0].conversationID) // 切换当前会话页
        if (videoMessageList[0].from !== this.userID) {
          this.$bus.$emit('isCalled')
        }
      }
      if (videoPayload.action === ACTION.VIDEO_CALL_ACTION_SPONSOR_CANCEL) {
        this.$bus.$emit('missCall')
      }
      if (videoPayload.action === ACTION.VIDEO_CALL_ACTION_REJECT) {
        this.$bus.$emit('isRefused')
      }
      if (videoPayload.action === ACTION.VIDEO_CALL_ACTION_SPONSOR_TIMEOUT) {
        this.$bus.$emit('missCall')
      }
      if (videoPayload.action === ACTION.VIDEO_CALL_ACTION_ACCEPTED) {
        this.$bus.$emit('isAccept')
      }
      if (videoPayload.action === ACTION.VIDEO_CALL_ACTION_HANGUP) {
        this.$bus.$emit('isHungUp')
      }
      if (videoPayload.action === ACTION.VIDEO_CALL_ACTION_LINE_BUSY) {
        this.$bus.$emit('isRefused')
      }
      if (videoPayload.action === ACTION.VIDEO_CALL_ACTION_ERROR) {
        this.$bus.$emit('isRefused')
      }
    },
    /**
     * 使用 window.Notification 进行全局的系统通知
     * @param {Message} message
     */
    notifyMe(message) {
      // 需检测浏览器支持和用户授权
      if (!('Notification' in window)) {
        return
      } else if (window.Notification.permission === 'granted') {
        this.handleNotify(message)
      } else if (window.Notification.permission !== 'denied') {
        window.Notification.requestPermission().then(permission => {
          // 如果用户同意，就可以向他们发送通知
          if (permission === 'granted') {
            this.handleNotify(message)
          }
        })
      }
    },
    handleNotify(message) {
      const notification = new window.Notification('有人提到了你', {
        icon: 'https://webim-1252463788.file.myqcloud.com/demo/img/logo.dc3be0d4.png',
        body: message.payload.text
      })
      notification.onclick = () => {
        window.focus()
        this.$store.dispatch('checkoutConversation', message.conversationID)
        notification.close()
      }
    },
    handleLinkClick() {
      MTA.clickStat('link_two', { click: 'true' })
    },
    /**
     * 收到有群成员退群/被踢出的groupTip时，需要将相关群成员从当前会话的群成员列表中移除
     * @param {Message[]} messageList
     */
    handleQuitGroupTip(messageList) {
      // 筛选出当前会话的退群/被踢群的 groupTip
      const groupTips = messageList.filter(message => {
        return this.currentConversation.conversationID === message.conversationID &&
          message.type === this.TIM.TYPES.MSG_GRP_TIP &&
          (message.payload.operationType === this.TIM.TYPES.GRP_TIP_MBR_QUIT ||
          message.payload.operationType === this.TIM.TYPES.GRP_TIP_MBR_KICKED_OUT)
      })
      // 清理当前会话的群成员列表
      if (groupTips.length > 0) {
        groupTips.forEach(groupTip => {
          if (Array.isArray(groupTip.payload.userIDList) || groupTip.payload.userIDList.length > 0) {
            this.$store.commit('deleteGroupMemberList', groupTip.payload.userIDList)
          }
        })
      }
    }
  }
}
</script>

<style lang="stylus">
body {
  overflow: hidden;
  margin: 0;
  font-family: 'Microsoft YaHei', '微软雅黑', 'MicrosoftJhengHei', 'Lantinghei SC', 'Open Sans', Arial, 'Hiragino Sans GB', 'STHeiti', 'WenQuanYi Micro Hei', SimSun, sans-serif;
  // font-family  "Helvetica Neue", Helvetica, Arial, "PingFang SC", "Hiragino Sans GB", "Heiti SC", "Microsoft YaHei", "WenQuanYi Micro Hei", sans-serif
  // text-shadow: $regular 0 0 0.05em
  background-color: white;
  -ms-scroll-chaining: chained;
  -ms-overflow-style: none;
  -ms-content-zooming: zoom;
  -ms-scroll-rails: none;
  -ms-content-zoom-limit-min: 100%;
  -ms-content-zoom-limit-max: 500%;
  -ms-scroll-snap-type: proximity;
  -ms-scroll-snap-points-x: snapList(100%, 200%, 300%, 400%, 500%);
  -ms-overflow-style: none;
  overflow: auto;

  div {
    box-sizing: border-box;

    &::before, &::after {
      box-sizing: border-box;
    }
  }
}
  .mapstyle {
    width: 300px;
    height: 214px;
    background: rgba(255, 255, 255, 1);
    // box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
    border-radius: 6px;
  }
#wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding-top: 100px;
}

.container
  position relative
  height 100vh
// TODO filter mac chrome 会有问题，下次修改可以去掉
.bg {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: -1;
  // background: url('~@/./assets/image/bg.jpg') no-repeat 0 0;
  // background-size: cover;
  background rgba(247,247,247,1);
  // filter blur(67px)
}

.loading {
  margin-top 26px;
  height: 100vh;
  width: 80vw;
  display: flex;
  justify-content: center;
}

.text-ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.chat-wrapper {
  margin-top: 3vh;
  width: 80vw;
  height: 80vh;
  width: 1280px;
  margin 0 auto;
  // box-shadow: 0 11px 20px 0 rgba(0, 0, 0, 0.3);

  .official-link {
    display: flex;
    text-decoration: none;
    color: #38c9ff;
    width: fit-content;
    float: right;
    height: 45px;
    align-items: center;
  }
}
  .buttonStyle, .buttonStyleNo {
    width: 88px;
    height: 32px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    line-height: 32px;
    text-align: center;
    border-radius: 4px;
    margin-right: 15px;
    cursor pointer;
    margin-bottom :15px;
  }

  .buttonStyle {
    background: #f82b18;
    color: rgba(255, 255, 255, 1);
  }

  .buttonStyleNo {
    background: #fff;
    color: rgba(0, 0, 0, 1);
  }
.topBtns {
  margin-bottom: 20px;

  ul, li {
    list-style: none;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin: 0px;
    padding: 0px;
    text-align: center;
    margin-right: 16px;
  }

  .btn {
    background-color: white;
    color: #000000;
    font-size: 14px;
    font-weight: 400;
    padding: 0px 12px;
    border-radius: 4px;
    cursor: pointer;
    height: 32px;
    text-align: center;

    &:hover {
      background: #f82b18;
      color: white;
    }
  }
}

/* 设置滚动条的样式 */
::-webkit-scrollbar {
  width: 3px;
  height: 3px;
}

/* 滚动槽 */
::-webkit-scrollbar-track {
  border-radius: 10px;
}

/* 滚动条滑块 */
::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background: rgba(0, 0, 0, 0.1);
}
</style>
